"use strict";

exports.__esModule = true;
exports.DeviceDetailsFields = DeviceDetailsFields;
var _react = _interopRequireDefault(require("react"));
var _Report = require("../Report");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for DeviceDetailsElement.
 */
function DeviceDetailsFields(props) {
  return /*#__PURE__*/_react["default"].createElement(_Report.ReportFields, props);
}